import { CancelButton, SaveButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { SimpleTableBase } from '@core/components/Table';
import { Grid } from '@material-ui/core';
import { cancelarAlert } from 'app/services/alerts';
import moment from 'moment';
import React, { useState } from 'react';

const getCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '');

const SelecionarContrato = ({
  vendaRequest,
  submitAndClose,
  modalSelecionarContratos,
  setModalSelecionarContratos,
  contratosVenda,
  setContratosVenda,
  showError,
}) => {
  const [selecao, setSelecao] = useState([]);
  const [pageContrato, setPageContrato] = useState(0);
  const [sizeContrato, setSizeContrato] = useState(15);

  const handleClose = () => {
    setModalSelecionarContratos(false);
    setSelecao([]);
    setContratosVenda([]);
  };

  const filtrarPagina = (paginaAtual, tamanhoPagina, contratos) => {
    const inicio = paginaAtual * tamanhoPagina;
    const fim = Math.min(inicio + tamanhoPagina, contratos?.length);
    return contratos?.length > 0 ? contratos?.slice(inicio, fim) : [];
  };

  const contratosPaginados = filtrarPagina(pageContrato, sizeContrato, contratosVenda);

  const columns = [
    {
      title: 'Identificador',
      name: 'identificador',
      getCellValue: (contrato) => contrato.identificador,
      align: 'left',
    },
    {
      title: 'Vigência do contrato',
      name: 'dataVigenciaInicial',
      getCellValue: (contrato) =>
        contrato?.dataVigenciaInicial &&
        contrato?.dataVigenciaFinal &&
        `${moment(contrato.dataVigenciaInicial).format('DD/MM/YYYY')} a ${moment(contrato.dataVigenciaFinal).format(
          'DD/MM/YYYY'
        )}`,
      align: 'center',
    },
    {
      title: 'Valor mensal (R$)',
      name: 'valor',
      getCellValue: (contrato) =>
        contrato?.valor && <div style={{ paddingRight: '16px' }}>{getCurrency(contrato.valor)}</div>,
      align: 'right',
      width: 180,
    },
  ];

  const handleSubmit = async () => {
    if (selecao.length > 1) {
      showError('Só é possível selecionar apenas um contrato.');
      return;
    }
    if (selecao.length === 1) {
      const contratoContaReceberDto = selecao[0];
      if (contratoContaReceberDto?.contratoContaReceberId) {
        if (vendaRequest.unificarCobrancaContratoVenda && contratoContaReceberDto?.situacao) {
          if (contratoContaReceberDto?.situacao === 'ABERTA') {
            cancelarAlert({
              opcoes: {
                title: 'Identificamos que já existe uma cobrança gerada para o contrato selecionado. Deseja unificar?',
                text: '',
              },
              confirmar: async () => {
                vendaRequest.contratoContaReceberId = contratoContaReceberDto.contratoContaReceberId;
                vendaRequest.excluirCobrancaJaGerada = true;
                await submitAndClose(vendaRequest);
                setSelecao([]);
                setContratosVenda([]);
              },
              cancelar: async () => {
                vendaRequest.excluirCobrancaJaGerada = false;
                vendaRequest.unificarCobrancaContratoVenda = false;
                await submitAndClose(vendaRequest);
                setSelecao([]);
                setContratosVenda([]);
              },
            });
          } else if (
            contratoContaReceberDto?.situacao === 'BAIXADA' ||
            contratoContaReceberDto?.situacao === 'PARCIAL'
          ) {
            cancelarAlert({
              opcoes: {
                title:
                  'Identificamos que já existe uma cobrança gerada e baixada para o contrato selecionado. Deseja gerar apenas a cobrança da venda?',
                text: '',
              },
              confirmar: async () => {
                vendaRequest.unificarCobrancaContratoVenda = false;
                vendaRequest.excluirCobrancaJaGerada = false;
                await submitAndClose(vendaRequest);
                setSelecao([]);
                setContratosVenda([]);
              },
            });
          }
        } else {
          vendaRequest.contratoContaReceberId = contratoContaReceberDto.contratoContaReceberId;
          vendaRequest.excluirCobrancaJaGerada = false;
          await submitAndClose(vendaRequest);
          setSelecao([]);
          setContratosVenda([]);
        }
      }
    }
  };

  return (
    <SimpleDialog open={modalSelecionarContratos} onClose={handleClose} innerScroll>
      <SimpleDialogContent
        header={{
          title: 'Selecionar contratos semelhantes a venda',
          toolbar: (
            <>
              <CancelButton title="cancelar" type="button" onClick={handleClose}>
                Fechar
              </CancelButton>

              <SaveButton type="submit" onClick={() => handleSubmit()}>
                Selecionar
              </SaveButton>
            </>
          ),
        }}
        content={
          <>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <SimpleTableBase
                hideTopSelection
                pageType="async"
                columns={columns}
                rows={contratosPaginados?.map((contrato) => ({
                  ...contrato,
                  id: contrato?.contratoId,
                }))}
                totalCount={contratosVenda?.length}
                searchBy=""
                selection={selecao}
                onSelectionChange={setSelecao}
                onCurrentPageChange={(params) => {
                  setPageContrato(params);
                }}
                onPageSizeChange={(params) => {
                  setSizeContrato(params);
                }}
              />
            </Grid>
          </>
        }
        contentStyle={{ padding: 0 }}
      />
    </SimpleDialog>
  );
};

export default SelecionarContrato;
